import $ from 'jquery';
import 'jqtree';
import 'jqtree/jqtree.css';

export default class GiftCategoryTree {
  constructor() {
    this.$tree = $('#tree');
    this.sortInput = '.js__node-sort input';
    this.parentInput = '.js__node-parent select';
    this.$form = $('.js__tree-submit-form');
    this.treeNodeSelector = '.jqtree-element';
    this.dataNodesSelector = '.js__tree-nodes';
    this.nodeTreeItems = '.jqtree-tree li';
    this.deleteCategoryBtn = '.js__gift-category-delete-btn';
    this.$confirmModal = $('.js__gift-category-confirm-modal');
    this.state = {
      isLoading: false,
    };
    this.btnTemplate = $('.js__tree-btn-template').detach();

    this.init();
  }

  submitForm() {
    if (!this.state.isLoading) {
      this.state.isLoading = true;
      this.$tree.addClass('loading');
      $.ajax({
        url: this.$form.attr('action'),
        type: this.$form.attr('method'),
        data: this.$form.serialize(),
        success: () => {
          this.$tree.removeClass('loading');
          this.state.isLoading = false;
        },
        error(xhr) {
          window.location.replace(xhr.responseJSON.redirect);
        },
      });
    }
  }

  bindEvents() {
    this.$tree.on('tree.move', event => {
      event.preventDefault();
      event.move_info.do_move();
      const tree = this.updateSortIndexes(JSON.parse($(event.currentTarget).tree('toJson')));
      this.$tree.tree('loadData', tree);
      this.updateInputs(tree);
      this.submitForm();
    });

    $('body').on('click', this.deleteCategoryBtn, e => {
      e.preventDefault();
      this.$confirmModal
        .modal({
          closable: false,
          approve: '.approve',
          deny: '.cancel',
          onApprove() {
            $('.gift-category-tree-wrapper').addClass('loading');
            window.location.replace($(e.currentTarget).attr('href'));
          },
        })
        .modal('show');
    });
  }

  updateSortIndexes(list) {
    return list.map((item, index) => ({
      ...item,
      ...(item.children && { children: this.updateSortIndexes(item.children) }),
      sort: index,
    }));
  }

  updateInputs(tree) {
    tree.forEach(item => {
      const $input = $(`.js__node-id-${item.id}`);
      const parents = this.$tree.tree('getNodeById', item.id).parent;
      $input.find(this.sortInput).val(item.sort);

      if (parents) {
        $input.find(this.parentInput).val(parents.id);
      }

      if (item.children) {
        this.updateInputs(item.children);
      }
    });
  }

  initTree(el, data) {
    el.tree({
      data,
      autoOpen: true,
      dragAndDrop: true,
      onCreateLi: (node, $li) => {
        $li.attr('data-node-id', node.id);
        const $labelsWrapper = $('<div class="ml-auto d-flex"></div>');
        $labelsWrapper.append($(`.js__gift-category-segments-label-${node.id}`).clone());
        $labelsWrapper.append($(`.js__gift-category-label-${node.id}`).clone());
        $li.find(this.treeNodeSelector).append($labelsWrapper);
        $li.find(this.treeNodeSelector).append(this.btnTemplate.clone());

        const $dataNode = $(`.js__node-id-${node.id}`);
        $li.find('.js__manage-prizes').attr('href', $dataNode.data('manage-prizes-url'));
        $li.find('.js__gift-category-show-btn').attr('href', $dataNode.data('show-url'));
        $li.find('.js__gift-category-delete-btn').attr('href', $dataNode.data('delete-url'));
        $li.find('.js__gift-category-edit-btn').attr('href', $dataNode.data('update-url'));
        $li.find('.dropdown').dropdown();
      },
      onCanMove: () => !this.state.isLoading,
    });
  }

  init() {
    this.initTree(this.$tree, this.$tree.data('json'));
    this.bindEvents();
  }
}
